module.exports = __webpack_public_path__ + "img/hornement.e21475c6.png";